import { mapActions } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
	components: {},
	props: {
		show: {
			type: Boolean
		}
	},
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				number: '',
				currentValue: '',
			},
			rules: {
				number: [
					{
						required: true,
						message: "Це поле є обов'язковим",
					},
				],
				currentValue: [
					{
						required: false
					},
				],
			},
		}
	},
	computed: {
		...mapGetters(['currentUserID', 'contractNumber'])
	},
	watch: {
		show(val) {
			this.dialogVisible = val;
		}
	},
	methods: {
		...mapActions(['saveMeter', 'getAllMetters', 'setRefresh']),
		submitForm() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.saveMeter({
						...this.ruleForm,
						added: new Date(),
						contractNumber: this.contractNumber
					}).then(() => {
						this.dialogVisible = false;
						this.$emit('update:show', false)
						this.$notify.success({
							title: 'Успіх!',
							message: 'Лічильник успішно додано.',
						});
						this.getAllMetters({
							userId: this.currentUserID,
							contractNumber: this.contractNumber
						});
						this.setRefresh(true);
					}).catch(() => {
						this.dialogVisible = false;
						this.$notify.error({
							title: 'Помилка',
							message: 'Сталася помилка під час додавання лічильника.',
						});
					});
				}
			});
		},
		cancelClick() {
			this.$emit('update:show', false)
			this.dialogVisible = false;
		}
	},
}